import { Injectable, inject } from '@angular/core';
import { signal } from '@angular/core';
import { Source } from '../../../@shared/components/custom-components/custom-sources/custom-sources.component';
import { SidePanelService } from './side-panel.service';

@Injectable({ providedIn: 'root' })
export class SourcesPanelService {
    private sidePanelService = inject(SidePanelService);

    isOpen = signal<boolean>(false);
    source = signal<Source | null>(null);

    openSource(source: Source): void {
        if (!source) {
            return;
        }
        this.source.set(source);
        this.isOpen.set(true);
        this.sidePanelService.open('SOURCES', { source });
    }

    close(): void {
        this.isOpen.set(false);
        this.sidePanelService.close();
    }

    clearSource(): void {
        this.source.set(null);
        this.isOpen.set(false);
        this.sidePanelService.close();
    }
}
